module.exports = __webpack_public_path__ + "static/img/5.32b744c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/5.jpg
// module id = aK0w
// module chunks = 1